module.exports = __webpack_public_path__ + "img/zncs-sj-yy.d1aa3944.png";